import { useId } from "react"
import { Link } from "@tanstack/react-router"
import { ChevronRight } from "lucide-react"
import { RiBugLine, RiShieldLine } from "@remixicon/react"
import { Switch } from "@/components/ui/switch"
import {
  setAdminLocal,
  useAdminLocal,
  useIsAdmin,
  useServerIsAdmin,
} from "@/hooks/use-is-admin"

export const ADMIN_NAV_ITEM = { label: "Admin", to: "/admin/waitlist" } as const

/** Admin-mode switch and admin entry as a grouped list, for the phone
 *  layout's Account page. Renders nothing for non-admins. */
export const AdminControls = () => {
  const switchId = useId()
  const isAdmin = useIsAdmin()
  const serverIsAdmin = useServerIsAdmin()
  const adminLocal = useAdminLocal()

  if (!serverIsAdmin) return null

  return (
    <div className="divide-y-[0.5px] divide-(--surface-hairline) overflow-hidden rounded-xl bg-(--surface-card)">
      <div className="flex min-h-12 items-center gap-3 px-4">
        <RiBugLine className="size-5 text-muted-foreground" aria-hidden />
        <label htmlFor={switchId} className="flex-1 text-(--heading)">
          Admin mode
        </label>
        <Switch
          id={switchId}
          checked={adminLocal}
          onCheckedChange={setAdminLocal}
        />
      </div>
      {isAdmin && (
        <Link
          to={ADMIN_NAV_ITEM.to}
          className="flex min-h-12 items-center gap-3 px-4"
        >
          <RiShieldLine className="size-5 text-muted-foreground" aria-hidden />
          <span className="flex-1 text-(--heading)">
            {ADMIN_NAV_ITEM.label}
          </span>
          <ChevronRight className="size-4 text-muted-foreground" aria-hidden />
        </Link>
      )}
    </div>
  )
}
